import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Observable, catchError, firstValueFrom, of } from 'rxjs';
import { RestApiService } from '../../core/services/rest-api-service';

export const marketGuard: CanActivateFn = (
  _route: ActivatedRouteSnapshot,
  _state: RouterStateSnapshot
):
  | Observable<boolean | UrlTree>
  | Promise<boolean | UrlTree>
  | boolean
  | UrlTree => {
  const router = inject(Router);
  const translateService = inject(TranslateService);
  //const dialogService = inject(DialogService);
  const permissionPromise = firstValueFrom(
    inject(RestApiService)
      .getMe()
      .pipe(
        catchError(_err => {
          return of(null);
        })
      )
  ).then(me => {
    if (!me)
      return router.createUrlTree(['/', translateService.currentLang, 'login']);
    return true; // T968 Registered Provider should see GloboMarket
    /*else if (me.type === Permission.OWNER) return true;
    else if (me.type === Permission.PROVIDER) {
      dialogService.openAlertDialog(
        _('Hibás felhasználó'),
        _(
          'Kérjük jelentkezz be a kutyás felhasználói fiókoddal, hogy megtekinthesd a GloboMarket lapot.'
        )
      );
      return router.createUrlTree(['/', translateService.currentLang, 'login']);
    } else
      return router.createUrlTree(['/', translateService.currentLang, 'home']);
    */
  });
  return permissionPromise;
};
